(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelSymbolDeleteController',ModelSymbolDeleteController);

    ModelSymbolDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelSymbol'];

    function ModelSymbolDeleteController($uibModalInstance, entity, ModelSymbol) {
        var vm = this;

        vm.modelSymbol = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModelSymbol.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
